import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function productsReducer(
  state = initialState.productsSearchOptions,
  action
) {
  switch (action.type) {
    case types.SET_PRODUCTS_TAB_SEARCHDATA:
      return action.data;
    default:
      return state;
  }
}
